<template>
    <div
        class="kgr-inputGroup"
        :class="{ 'with-errors': error.forField('file') }"
    >
        <div class="kgr-inputGroup__label ui-droppable">
            {{ $t('avatar') }}
        </div>

        <div class="kgr-postfix kgr-postfix--gutters kgr-postfix--center kgr-row kgr-row--smallMargin">
            <div
                v-if="hasAvatar"
                class="kgr-postfix__fixed"
            >
                <div class="kgr-profileImage kgr-profileImage--sizeM">
                    <img
                        :src="avatarUrl()"
                        class="kgr-profileImage__image"
                    />
                </div>
            </div>
            <div class="kgr-postfix__fluid">
                <kgr-file-chooser @change="onAvatarChange" />
                <template v-if="avatarFile">
                    <hr class="kgr-separator kgr-separator--light" />
                    <kgr-button
                        :value="$t('Foto hochladen')"
                        :pending="pendingUpload"
                        type="blue"
                        @click="uploadAvatar"
                    />
                </template>
                <template v-if="hasAvatar && !avatarFile">
                    <hr class="kgr-separator kgr-separator--light" />
                    <a
                        class="kgr-button kgr-button--small kgr-button--danger"
                        href="javascript:void(0);"
                        @click="deleteAvatar()"
                    >{{ $t('Foto löschen?') }}</a>
                    <input
                        id="check_remove_image"
                        type="hidden"
                        value="0"
                        name="check_remove_image"
                    />
                </template>
            </div>
        </div>

        <div
            v-if="error.forField('file')"
            class="kgr-inputGroup__text kgr-inputGroup__text--error"
        >
            {{ error.messageForField('file') }}
        </div>
        <div class="kgr-inputGroup__text">
            {{ $t('Hier können Sie ein Profilbild einfügen. Die Grafikdatei (z.B. JPG, PNG oder GIF) sollte eine Mindestbreite von 300 Pixel haben und darf eine Dateigröße von 2 MB nicht überschreiten.') }}
        </div>
    </div>
</template>

<script>
import ChildRepository from '../../../js/repository/ChildRepository';
import Error from '../../../js/model/Error';
import FileChooser from '../../common/file/FileChooser.vue';
import KgrButton from '../../common/form/button/KgrButton.vue';

export default {
    components: {
        'kgr-button': KgrButton,
        'kgr-file-chooser': FileChooser,
    },
    props: {
        childId: {
            type: Number,
            required: true,
        },
        childGender: {
            type: String,
            required: true,
        },
        childFilename: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            error: new Error(),
            hasAvatar: this.childFilename !== '',
            avatarFile: null,
            pendingUpload: false,
        };
    },
    methods: {
        avatarUrl() {
            if (!this.hasAvatar) {
                if (!this.childGender || this.childGender === 'child.gender.u') {
                    return kgr.assetsUrls.avatarUnknown;
                } else if (this.childGender === 'child.gender.f') {
                    return kgr.assetsUrls.avatarFemale;
                }

                return kgr.assetsUrls.avatarMale;
            }

            return ChildRepository.avatarUrl(this.childId, 'profile_image_m', true);
        },
        deleteAvatar() {
            showConfirm(this.$t('confirm'), this.$t('Soll das Foto wirklich gelöscht werden?'), () => {
                ChildRepository.removeAvatar(this.childId)
                    .then(() => {
                        this.error = new Error();
                        this.hasAvatar = false;
                        this.$notify.success('Foto erfolgreich gelöscht');
                    })
                    .catch((error) => this.handleError(error));

                this.avatarFile = null;
            }, 'Ok');
        },
        onAvatarChange(avatarFile) {
            this.avatarFile = avatarFile;
        },
        uploadAvatar() {
            if (this.avatarFile) {
                this.pendingUpload = true;
                ChildRepository.uploadAvatar(this.childId, this.avatarFile)
                    .then(() => {
                        this.error = new Error();
                        this.hasAvatar = true;
                        this.avatarFile = null;

                        this.$forceUpdate();
                        this.$notify.success('Foto erfolgreich hochgeladen');
                    })
                    .catch((error) => this.handleError(error))
                    .finally(() => this.pendingUpload = false);
            }
        },
        handleError(error) {
            this.error = error;
            this.$notify.error('saveChanges.error');
        },
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .form-widget {
    &.block {
        width: 100%;
    }
    &.error-state {
        border-color: #f44336;
    }

    .upload-button {
        margin-top: 5px;
        margin-left: 10px;
        margin-bottom: 10px;
    }
}
</style>
